// services/LoadingManagementService.js (or wherever this is)
import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getUserList(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/selectors/users?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getMaterialsList(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/selectors/materials?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}
async function getGroupsSelectors(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/selectors/groups?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}


async function getAreasList(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/selectors/auction-areas?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getAuctionList(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/selectors/auctions?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getVehiclesList(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/selectors/vehicles?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}


async function createDeliverySchedule(payload, isFormData = false) {
  const user = getLoggedUser(); // Make sure this is available
  
  const config = {
    headers: {
      Authorization: 'Bearer ' + user.token,
    },
  };

  // If it's FormData, don't set Content-Type (browser will set it)
  // If it's JSON, set Content-Type to application/json
  if (!isFormData) {
    config.headers['Content-Type'] = 'application/json';
  }

  try {
    const { data: response } = await axios.post(
      `${endpoint}/delivery-schedules`, 
      payload, 
      config
    );
    
    // Return the response data
    return response;
  } catch (error) {
    console.error('API Error:', error);
    
    // Return a consistent error response structure
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
    };
  }
}

async function getLoadingManagement(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/loading-management?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}



export { getUserList, getAreasList, getAuctionList, getVehiclesList, getMaterialsList, getGroupsSelectors, createDeliverySchedule  , getLoadingManagement};